import { Box, Grid, Stack } from '@mui/material';
import { ERegistryPermission } from 'enum/ERegistryPermission'
import { colors } from 'styles/colors';
import { useGetRegistries } from 'hooks/useRegistries';
import RegistryItem from '../RegistryItem/RegistryItem';
import CustomText from 'components/common/CustomText/CustomText';
import FolderIcon from '../../../assets/icons/registryicon.png';
import UserCardSkeleton from 'components/user/UserCardSkeleton/UserCardSkeleton';
import RegistryItemSkeleton from '../RegistryItemSkeleton/RegistryItemSkeleton';
import { EBaseRegistriesPath } from 'common/constants';

interface Props {
  group: ERegistryPermission;
}

export default function Registries({ group }: Props) {

  const { data: registries, isLoading, refetch: refetchRegistries } = useGetRegistries({
    group,
    page: 0,
    pageLimit: 100,
  })


  if (isLoading) {
    return (
      <Grid container spacing={1.5}>
        {Array.from({ length: 15 }).map((_, index) => (
          <Grid
            key={index}
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}
          >
            <RegistryItemSkeleton />
          </Grid>
        ))}
      </Grid>
    );
  }
  // ✅ Empty state
  if (!registries || registries?.data?.length === 0) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        textAlign="center"
        gap={2}
        minHeight={'80vh'}
      >
        <Box height={100}>
          <Box
            component={'img'}
            src={FolderIcon}
            sx={{
              height: 100,
              opacity: 0.5,
            }}
          />
          {/* <UsersIconOutline
            size={100}
            color={hexWithOpacity(colors.secondary, 0.5)}
          /> */}
        </Box>

        <Box>
          <CustomText text="No registries available" fontWeight={600} color={colors.secondary} />
          <CustomText text="Click “Create Registry” to create your first registry." color={colors.secondary} />
        </Box>
      </Box>
    );
  }


  return (
    <Grid
      container
      spacing={1.5}
    >
      {registries?.data?.map((item: any, index: any) => {
        return (
          <RegistryItem
            key={item.id}
            item={item}
            refetch={refetchRegistries}
            basePath={EBaseRegistriesPath.ALL_REGISTRIES}
          />
        )
      })}
    </Grid>
  )
}
